import { z } from 'zod'

export const FeedbackType = {
  BUG: 'BUG',
  IDEA: 'IDEA',
} as const
export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType]

export const FeedbackPriority = {
  CRITICAL: 'CRITICAL',
  NORMAL: 'NORMAL',
  LOW: 'LOW',
} as const
export type FeedbackPriority = (typeof FeedbackPriority)[keyof typeof FeedbackPriority]

export const FeedbackStatus = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  FIXED: 'FIXED',
  REJECTED: 'REJECTED',
} as const
export type FeedbackStatus = (typeof FeedbackStatus)[keyof typeof FeedbackStatus]

export const FeedbackTypeSchema = z.enum(['BUG', 'IDEA'])
export const FeedbackPrioritySchema = z.enum(['CRITICAL', 'NORMAL', 'LOW'])
export const FeedbackStatusSchema = z.enum(['NEW', 'IN_PROGRESS', 'FIXED', 'REJECTED'])

export const CreateFeedbackSchema = z.object({
  type: FeedbackTypeSchema,
  priority: FeedbackPrioritySchema,
  title: z.string().trim().min(1).max(200),
  description: z.string().max(10000).nullable().optional(),
})
export type CreateFeedbackDto = z.infer<typeof CreateFeedbackSchema>

export interface FeedbackAuthor {
  id: string
  email: string
  name: string | null
  role: 'ADMIN' | 'MANAGER' | 'PROCUREMENT'
}

export interface FeedbackCommentDto {
  id: string
  feedbackId: string
  authorId: string
  author: FeedbackAuthor | null
  text: string
  screenshot: string | null
  createdAt: string
}

/** Ответ поддержки из «Пульта проектов»: текст и/или файлы. */
export interface FeedbackReplyDto {
  id: string
  /** Текст ответа; пустой, если ответ — только файлы. */
  text: string
  /** Имена файлов: открываются по /api/uploads/feedback/<имя>. */
  files: string[]
  createdAt: string
}

export interface FeedbackDto {
  id: string
  type: FeedbackType
  priority: FeedbackPriority
  title: string
  description: string | null
  screenshot: string | null
  status: FeedbackStatus
  adminReply: string | null
  authorId: string
  author: FeedbackAuthor | null
  comments: FeedbackCommentDto[]
  /** Ответы поддержки из «Пульта проектов», старые сверху. */
  replies: FeedbackReplyDto[]
  createdAt: string
  updatedAt: string
}

export interface FeedbackListResponse {
  items: FeedbackDto[]
  total: number
  page: number
  limit: number
}
